import { ValidationError } from "@common/types";
import { generateName } from "@common/Common";

export class EvalModelClonerViewModel
{
    opened: boolean = false;

    sourceId: number | null = null;
    name: string | null = null;
    operationInProgress: boolean = false;
    cloneFailed: boolean = false;

    errors: ValidationError[] = [];

    show(sourceId: number, sourceName: string)
    {
        this.sourceId = sourceId;
        this.name = generateName(sourceName);
        this.operationInProgress = false;
        this.cloneFailed = false;

        this.clearValidationErrors();

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.sourceId = null;
        this.name = null;
        this.operationInProgress = false;
        this.cloneFailed = false;

        this.clearValidationErrors();
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.errors = errors;
        this.cloneFailed = true;
        this.operationInProgress = false;
    }

    clearValidationErrors()
    {
        this.errors = [];
        this.cloneFailed = false;
    }
}